import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, watch } from "vue";
import ShiftTable, { Shift, Date, Employee } from "./ShiftTable.vue";
import MonthPicker from "@/components/picker/MonthPicker.vue";
import { DateTime } from "luxon";
import Store from "@/store";
import { useApi } from "@/plugins/api/api";

type Props = {
  value: boolean;
};
type Emits = {
  (e: "input", val: boolean): void;
  (e: "close"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchShiftDialog',
  props: {
    value: { type: Boolean }
  },
  emits: ["input", "close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
};

const { $post, Paths } = useApi();




const isOpen = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const interval = ref<Date[]>([]);
const shift = ref<Employee[]>([]);
const items = computed(() =>
  shift.value.filter(e => e.employeeId === Store.state.user.incode)
);

const format = "yyyy-MM";
const formatd = "yyyy-MM-dd";
const ymd = ref(DateTime.now().toFormat(formatd));
const month = ref(DateTime.now().toFormat(format));

const getShiftTable = async () => {
  const date = DateTime.fromFormat(month.value, format).toISODate();
  const request = { affiliationId: Store.state.workIncode, date };
  const response = await $post<Shift>(Paths.approval.shiftTable.post, request);
  if (response) {
    interval.value = response.interval;
    shift.value = response.shift;
  }
};

const setstartmonth = async () => {
  console.log("setstartmonth", ymd.value);
  const dtstr = ymd.value?.split("-");
  console.log("dtstr", dtstr);
  if (dtstr != undefined && Number(dtstr[2]) >= 16) {
    console.log("dtstr", dtstr[2]);
    if (dtstr != undefined && dtstr[1] == "12") {
      dtstr[0] = String(Number(dtstr[0]) + 1);
      dtstr[1] = "01";
    } else if (dtstr != undefined) {
      const m = Number(dtstr[1]) + 1;
      if (m < 10) {
        dtstr[1] = "0" + String(m);
      } else {
        dtstr[1] = String(m);
      }
    }
    if (dtstr != undefined) month.value = dtstr[0] + "-" + dtstr[1];
    console.log("month", month.value);
  } else {
    await getShiftTable();
  }
};

const onRight = async () => {
  const date = DateTime.fromFormat(month.value, format).toISODate();
  const dtstr = date?.split("-");
  if (dtstr != undefined && dtstr[1] == "12") {
    dtstr[0] = String(Number(dtstr[0]) + 1);
    dtstr[1] = "01";
  } else if (dtstr != undefined) {
    const m = Number(dtstr[1]) + 1;
    if (m < 10) {
      dtstr[1] = "0" + String(m);
    } else {
      dtstr[1] = String(m);
    }
  }
  if (dtstr != undefined) month.value = dtstr[0] + "-" + dtstr[1];
  // await getShiftTable();
};

const onLeft = async () => {
  const date = DateTime.fromFormat(month.value, format).toISODate();
  const dtstr = date?.split("-");
  console.log("dtstr", dtstr);
  if (dtstr != undefined && dtstr[1] == "01") {
    dtstr[0] = String(Number(dtstr[0]) - 1);
    dtstr[1] = "12";
  } else if (dtstr != undefined) {
    const m = Number(dtstr[1]) - 1;
    if (m < 10) {
      dtstr[1] = "0" + String(m);
    } else {
      dtstr[1] = String(m);
    }
  }
  if (dtstr != undefined) month.value = dtstr[0] + "-" + dtstr[1];
  // await getShiftTable();
};

const onClose = () => {
  emits("close");
  isOpen.value = false;
};

watch(
  () => month.value,
  async () => {
    await getShiftTable();
  }
);

watch(isOpen, async val => {
  if (val) {
    // await getShiftTable();
    await setstartmonth();
  }
});

// onMounted(async () => {
//   await getShiftTable();
// });

return { __sfc: true,$post, Paths, props, emits, isOpen, interval, shift, items, format, formatd, ymd, month, getShiftTable, setstartmonth, onRight, onLeft, onClose, ShiftTable, MonthPicker }
}

})